<div class="ticket-container state-alert" [class.light]="isLight" [class.dark]="!isLight">
  <div class="main-info-wrapper">
    <div class="main-info gap-3">
      <div class="icon">
        <app-icam-icon [iconName]="'alert'" [isDefault]="true" iconHeight="35px" />
      </div>
      <div>
        <h2 class="title fw-semibold my-0 py-0 title-danger">
          <span>{{ 'TICKET.ALERT' | translate }} </span>
          <span>{{ machine?.status | uppercase }}</span>
        </h2>
      </div>
    </div>
    @if (machine?.alarmMessage) {
      <div class="error-or-date pt-2">
        <span class="fw-semibold">{{ 'TICKET.ERROR' | translate }}: </span>
        {{ machine?.alarmMessage }}
      </div>
    }
  </div>
  <div class="details-container">
    <div>
      <span class="fw-semibold">{{ 'TICKET.MACHINE_DATA' | translate }} </span>
    </div>
    <div class="details">
      <div class="name ticket-info-first">
        <span class="fw-semibold">{{ 'TICKET.NAME' | translate }}: </span>{{ machine?.assetName }}
      </div>
      <div class="number ticket-info px-3">
        <span class="fw-semibold">{{ 'TICKET.NUMBER' | translate }}: </span>{{ machine?.serialNumber }}
      </div>
      <div class="type ticket-info px-3">
        <span class="fw-semibold">{{ 'TICKET.TYPE' | translate }}: </span>{{ machine?.typology }}
      </div>
    </div>
  </div>
  <div class="button-container">
    <button
      class="btn-alert"
      *appHasRole="['CUSTOMER', 'CUSTOMER_PARTNER', 'PARTNER', 'ADMIN']"
      [routerLink]="['/ticket', 'new']"
      [queryParams]="{ serialNumber: machine?.serialNumber, errorMessage: machine?.alarmMessage || undefined }"
    >
      {{ 'TICKET.NEW_TICKET' | translate }}
    </button>
  </div>
</div>
